import produce from 'immer';

import {
  FETCH_WATCH_HISTORY_SUCCEEDED,
  UPDATE_WATCH_HISTORY_SUCCEEDED,
  DELETE_WATCH_HISTORY_OPTIMISTIC,
  DELETE_ALL_WATCH_HISTORY_OPTIMISTIC,
  LOGOUT,
} from '../../constants/actionTypes';

const initState = [];

export default produce((draft, action) => {
  switch (action.type) {
    case FETCH_WATCH_HISTORY_SUCCEEDED: {
      return action.payload.result;
    }

    case UPDATE_WATCH_HISTORY_SUCCEEDED: {
      const dramaId = action.payload.dramaId;

      if (!draft.includes(dramaId)) {
        draft.unshift(dramaId);
      }

      return;
    }

    case DELETE_WATCH_HISTORY_OPTIMISTIC: {
      const dramaId = action.payload;
      const index = draft.findIndex((id) => id === dramaId);

      if (index !== -1) {
        draft.splice(index, 1);
      }

      return;
    }

    case DELETE_ALL_WATCH_HISTORY_OPTIMISTIC:
    case LOGOUT: {
      return initState;
    }
  }
}, initState);
